import React, { PureComponent } from 'react'
import './wallet.css'
import { Input, Button } from 'antd'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Icon } from 'antd';
import { connect } from 'react-redux'
import { login } from '../../redux-flow/actions/wallet'

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class LoginWallet extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            password: null,
            error: false
        }
    }

    handleChange = (e) => {
        this.setState({
            password: e.target.value
        })
    }

    submitForm = () => {
        const page = document.location.pathname
        if(this.state.password === null || this.state.password === '') {
            this.setState({
                error: true
            })
        } else {
            this.props.handleSubmit(this.state.password, this.props.email, this.props.userid, page)
        }
    }

    handleKeyPress = (e) => {
        const page = document.location.pathname
        if(e.key === 'Enter') {
            if(this.state.password === null || this.state.password === '') {
                this.setState({
                    error: true
                })
            } else {
                this.props.handleSubmit(this.state.password, this.props.email, this.props.userid, page)
            }
        }
    }

    render() {
        const { isLoading, success, loginExpired, page } = this.props
        return (
            <>
            <Container>
                <Row>
                    <Col md={12} className="d-flex justify-content-center">
                        <div className="loginWalletWrapper loginWrapper">
                            {!success ? 
                                <div class="alert alert-danger text-center" role="alert">
                                    Senha incorreta.
                                </div> : ''}
                            {loginExpired ? 
                                <div class="alert alert-danger text-center" role="alert">
                                    Sua sessão expirou. Por favor, faça login novamente.
                                </div> : ''}
                                <h4 className="tx-pink font-weight-bold">Digite sua senha para continuar.</h4>
                                <Input.Password  onKeyPress={(e) => this.handleKeyPress(e)} onChange={(e) => this.handleChange(e)} className="formInput" />
                                {this.state.error ? (<div><small style={{color: 'red'}}>Este campo é obrigatório</small><br /></div>) : ''}
                                {isLoading ? <LoadingComponent /> : <Button onClick={() => this.submitForm()} className="mt-3 text-center w-100 pt-1 btnGrafico">Acessar</Button> }
                        </div>
                    </Col>
                </Row>
            </Container>
            </>
        )
    }
}

const mapStateToProps = state => ({
    isLoading: state.wallet.isLoading,
    success: state.wallet.success,
    loginExpired: state.wallet.loginExpired,
    userid: state.login.userid,
})
    
const mapDispatchToProps = dispatch => ({
    handleSubmit: (pass, email, userid, page) => {
        dispatch(login(pass, email, userid, page))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginWallet)